<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">
<!--        {{ addressData?.id ? $t('addressEditModalTitle') : $t('addressCreateModalTitle') }}-->
        {{ $t('Address') }}
      </div>
    </template>

    <form autocomplete="off">
<!--      <Spinner v-if="dataIsSending"/>-->
      <div class="p-formgrid p-grid p-pt-3">
        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
          <div class="p-float-label">
            <InputText id="address"
                       v-model.trim="addressData.address"
                       autocomplete="off"
                       name="addr_line1" />
            <label for="address">{{ $t('Address') }}</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
          <div class="p-float-label">
            <InputText id="address2"
                       v-model.trim="addressData.address2"
                       autocomplete="off"
                       name="addr_line2" />
            <label for="address2">{{ $t('Address') }} 2</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
          <div class="p-float-label">
            <InputText id="city"
                       v-model.trim="addressData.city"
                       autocomplete="off"
                       name="addr_city" />
            <label for="city">{{ $t('City') }}</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-12 p-md-7 p-lg-7 p-mb-5">
          <div class="p-float-label">
            <InputText id="state"
                       v-model.trim="addressData.state"
                       autocomplete="off"
                       name="addr_state" />
            <label for="state">{{ $t('State') }}</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-12 p-md-5 p-lg-5 p-mb-5">
          <div class="p-float-label">
            <InputText id="postcode"
                       v-model.trim="addressData.postcode"
                       autocomplete="off"
                       name="addr_postcode" />
            <label for="postcode">{{ $t('Postcode') }}</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12">
          <CountryDropdown v-model="selectedCountry"
                           :countryId="addressData.country_id"
                           :resetOnClose="true"
                           v-model:isInvalid="countryIsInvalid"
                           :submitted="submitted"
                           :required="true"
                           :visible="visible"
                           :showClear="true"
                           inputId="customer-address-country-dropdown"
                           label="Country"/>
        </div>

<!--        <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12">-->
<!--          <LimitedCharsTextarea :submitted="submitted"-->
<!--                                :rows="3"-->
<!--                                v-model="addressData.comment"-->
<!--                                :maxChars="commentMaxChars"-->
<!--                                :autocomplete="'new-password'"-->
<!--                                :id="'user-address-comment'"-->
<!--                                :label="$t('Notes')" />-->
<!--        </div>-->
      </div>
    </form>
    <template #footer>
      <Button :label="$t('Cancel')"
              icon="pi pi-times"
              class="p-button-text"
              @click="close"/>
      <!--              :disabled="dataIsSending"-->
      <Button :label="addressData?.id ? $t('Update') : $t('Add')"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import showErrorsMixins from "@/mixins/showErrorsMixins";
import CountryDropdown from "@/components/CountryDropdown.vue";

export default {
  mixins: [ showErrorsMixins ],
  components: {CountryDropdown},
  emits: ['close', 'update-item', 'update-items'],
  name: 'AddressModal',
  props: {
    item: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      countryIsInvalid: false,
      commentMaxChars: 500,
      // dataIsSending: false,
      // disableSaveButton: false,
      // countriesDataIsLoading: false,
      submitted: false,
      addressData: {},
      // originalAddress: {},
      countries: [],
      selectedCountry: null,
    }
  },
  watch: {
    item: {
      immediate: true,
      handler(value) {
        this.addressData = value ? { ...value } : {}

        this.getCountries().then(() => {
          if (value?.country_id) {
            this.selectedCountry = this.countries?.find(country => Number(country.id) === Number(value.country_id)) ?? null
          } else {
            this.selectedCountry = this.countries?.find(country => Number(country.is_default)) ?? null
          }
        })
      }
    },
    visible() {
      if (!this.visible) {
        // this.disableSaveButton = false
        // this.dataIsSending = false
        this.submitted = false
        this.selectedCountry = null
      }
    },
  },
  methods: {
    async getCountries() {
      if (this.countriesDataIsLoading || !this.$store.getters.userCanGetData) return
      this.countriesDataIsLoading = true
      try {
        // const { data, status } = await httpClient('country')
        const { data, status } = await httpClient('country/modal-countries')
        if (status === 200 && data) {
          this.countries = data
          this.selectCountry()
        } else {
          this.countries = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.countriesDataIsLoading = false
      }
    },
    selectCountry() {
      if (this.selectedCountry || !this.countries?.length) return false

      const defaultCountry = this.countries.find(country => Number(country.is_default)) ?? null

      const country = this.addressData?.country?.name
          ? this.countries.find(country => country.name === this.addressData.country.name)
          : null

      this.selectedCountry = country || defaultCountry
    },
    saveItem() {
      this.submitted = true
      if (!this.addressData ||
          (this.addressData.comment && this.addressData.comment.length > this.commentMaxChars) ||
          !this.selectedCountry ||
          this.countryIsInvalid) {
        return
      }

      // this.dataIsSending = true

      const newAddress = {
        id: this.addressData.id,
        user_id: this.userId,
        address: this.addressData.address ?? null,
        address2: this.addressData.address2 ?? null,
        city: this.addressData.city ?? null,
        state: this.addressData.state ?? null,
        postcode: this.addressData.postcode ?? null,
        country_id: this.selectedCountry?.id ? +this.selectedCountry.id : null,
        comment: this.addressData.comment ?? null,
        country: this.selectedCountry ?? null,
      }
      this.$emit('update-item', newAddress)
      this.submitted = false
      this.close()
    },
    close() {
      this.$emit('close')
      this.submitted = false
      this.selectedCountry = null
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '400px', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '400px', marginTop: '25px'}
      } else {
        return {position: 'absolute', top: 0, width: '400px', marginTop: '50px'}
      }
    }
  }
}
</script>